/* Base translations · Forms page and form renderer — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): formsPage, formRenderer. */
export const I18N_BASE_FORMS = {
  en: {
    formsPage: {
      tabLabels: {
        planning: "Planning",
        risk_assessment_forms: "Risk Assessment Forms",
        risk_a9001_pointer: "Fraud red flags (ISA 240)",
        completion: "Completion",
        specialized_and_other_considerations: "Specialized & Other Considerations",
      },
      // K1 — Planning / RA / Completion folder names (canonical labels).
      // The Forms page consumes these when lang === "ar"; on EN it keeps
      // the tab.folderName from forms_library.json (verbatim).
      folders: {
        team_discussions: "Team Discussions",
        overall_audit_strategy: "Overall Audit Strategy",
        client_meetings_deliverables: "Client Meetings and Deliverables",
        time_budget: "Time Budget",
        materiality: "Materiality",
        specialized: "Specialized (400/401/402(a))",
        identified_risks: "Identified Risks (Risk reports)",
        control_design_fsa: "Control Design (including FSA)",
        risk_assessment_procedures: "Risk Assessment Procedures",
        understanding_the_entity: "Understanding the Entity",
        accounting_estimates: "Accounting Estimates",
        fraud_and_going_concern: "Fraud & Going Concern",
        related_parties: "Related Parties",
        service_organizations: "Service Organizations",
        sampling_basis_methodology: "Sampling Basis & Methodology",
        noclar: "Laws & Regulations Compliance (NOCLAR)",
        misstatements: "Misstatements",
        subsequent_events: "Subsequent Events",
        reporting: "Reporting",
        documentation: "Documentation",
        management_representation: "Management Representation Letter",
        audit_completion: "Audit Completion Checklist",
        report_approval: "Report Approval and Transmittal",
        communications: "Communications with TCWG and Management",
        completion_support_documents: "Completion Support Documents",
        final_analytical_review: "Final Analytical Review",
        kam_determination: "Key Audit Matters",
        modified_opinion: "Modified Opinion Assessment",
        eom_om_paragraphs: "Emphasis of Matter / Other Matter",
        other_information_review: "Other Information Review",
        comparative_information: "Comparative Information",
        management_letter_icd: "Management Letter (Internal Control Deficiencies)",
        special_purpose_framework: "Special Purpose Framework Reporting",
        single_fs_element: "Single Financial Statement / Specific Element",
        summary_fs: "Summary Financial Statements",
      },
      toastNoRefMatch: 'No form matches ref "{ref}"',
      toastFormNotFound: "Form not found in this engagement",
      bulkConfirm: 'Run AI Suggest across every form in the "{tab}" tab? This may take a minute or two for a large tab.',
      bulkNoJobId: "Backend did not return a job id",
      bulkQueuedMsg: "Queued…",
      bulkComplete: "AI Suggest complete — {done} of {total} forms updated{failed}",
      bulkCompleteFailedTail: " · {failed} failed",
      bulkFailed: "Bulk AI Suggest failed",
      bulkFailedGeneric: "Could not start bulk AI Suggest",
      pdfReady: "PDF ready",
      pdfFailed: "PDF export failed",
      noRollMsg: "No prior-year forms rolled — either all forms already have entries this year, or nothing to roll from.",
      rolledMsg: "Rolled forward {n} from FY {year}. Review and save each one.",
      addonsCarriedMsg: " {n} carried over from prior year.",
      rollFailed: "Roll forward failed",
      noQueryMatch: 'No form matches "{q}"',
      loading: "Loading forms library…",
      selectEngagement: "Select an engagement from the top bar to view {tab} forms.",
      tabNotFound: 'Tab "{tabId}" not found in forms library.',
      totalItems: "{folders} folders · {total} total items",
      searchPlaceholder: "Search ref-no… (e.g. 104)",
      noMatches: "No matches",
      sortFolder: "folder",
      sortRefNo: "ref-no",
      rollForwardBtn: "Roll forward prior year",
      aiSuggestingLabel: "AI suggesting… {pct}%",
      aiSuggestAllBtn: "AI Suggest All",
      exportPdfBtn: "Export PDF",
      completionLabel: "Completion",
      allByRef: "All forms by ref-no",
      dragDisabledPre: "Drag-reorder disabled — switch to ",
      dragDisabledFolderBold: "folder",
      dragDisabledPost: " to reorder",
      notApplicableBadge: "Not Applicable",
      markApplicableTitle: "Mark applicable",
      markNaTitle: "Mark N/A",
      naReasonPrompt: "Why is this form not applicable? (short reason, recorded on the form and in the sign-offs view)", naReasonRequired: "A short reason is needed to mark a form N/A.",   // Batch 14 · M11
      markedApplicable: "Marked applicable",
      markedNa: "Marked Not Applicable",
      deletePermanentlyTitle: "Delete permanently",
      rollDialogTitle: "Roll forward from prior year",
      rollDialogBodyPre: "This copies last year's form answers for this client into the current engagement. Only forms you ",
      rollDialogBodyBold: "haven't touched yet",
      rollDialogBodyPost: " will be filled — your current work is never overwritten. Signature and date fields are cleared automatically.",
      carryAddonsBold: "Also carry over add-on forms from the prior year.",
      carryAddonsBody: " If the prior engagement had extra forms (e.g. 211(a) Related Parties, 313(a) External Confirmations) added from the Document Library, they'll be added to this engagement too so the audit programme stays stable year-over-year.",
      cancelBtn: "Cancel",
      rollingLabel: "Rolling forward…",
      continueBtn: "Continue",
    },
    formRenderer: {
      loadingForm: "Loading form…",
      failedLoad: "Failed to load form",
      savedToast: "Saved",
      failedSave: "Failed to save",
      aiConfirm: "AI Suggest will draft Yes/No/N/A responses for every checklist item on this form, using the engagement's GL summary and prior-year answers. Your existing answers on those items will be overwritten (draft only — you still review and save). Continue?",
      aiDrafting: "Drafting AI suggestions… this can take 10-30 seconds.",
      aiDraftedPrefix: "AI drafted",
      aiDraftedSuffixPY: " (informed by prior year)",
      aiDraftedTail: ". Review each item, then Save.",
      aiSuggestFailed: "AI suggest failed",
      discardConfirm: "Discard unsaved changes?",
      notApplicable: "Not Applicable",
      supportDocs: "Supporting documents for this form",
      letterBody: "Letter body (editable)",
      letterPlaceholder: "Draft the management representation letter here — topics: Financial statements, Information provided, Fraud, Laws and regulations, Going concern. Letter date must equal the auditor's report date.",
      letterDate: "Date of the letter",
      letterAttached: "Signed letter attached",
      letterNotAttached: "Signed letter not attached yet — upload it under Supporting documents below",
      letterRule: "Answered when the letter body is present, the signed letter is attached and the date is entered.",
      naReason: "reason: {reason}", naReasonNotRecorded: "reason not recorded",   // Batch 14 · M11
      fromRecord: "Shown from the {source} (one source) — edit it there.",
      fromRecordOpen: "Open the Materiality page",
      ajeRegisterNote: "Filled from the posted adjusting entries (one source) — read-only here.",
      ajeManualRow: "manual (before adjusting entries)",
      ajeOpen: "Open Adjusting entries",
      documentReviewTab: "Document Review",
      docRepoNote: "For now, use the main {docReview} tab to upload files and link them here manually via reference numbers. Native inline uploader for this form ships in the next iteration.",
      close: "Close",
      savingBtn: "Saving…",
      saveBtn: "Save",
      selectOption: "— select —",
      typeName: "Type full name",
      signedAtAuto: "signed at (auto)",
      commentOptional: "Comment (optional)",
      aiSuggestedReview: "AI-suggested — review required",
      aiSuggestBtn: "AI Suggest",
      addRow: "Add row",
      lastSaved: "Last saved {when} by {by}",
      savedFooter: "Saved · {when} · {by}",
      notSavedYet: "Not saved yet",
      refPrefix: "Ref: {ref}",
    },
  },
  ar: {
    formsPage: {
      tabLabels: {
        planning: "التخطيط",
        risk_assessment_forms: "نماذج تقييم المخاطر",
        risk_a9001_pointer: "مؤشرات الاحتيال (ISA 240)",
        completion: "الإكمال",
        specialized_and_other_considerations: "متخصصة واعتبارات أخرى",
      },
      // K1 — Arabic folder labels used on the Planning / RA / Completion
      // list pages so folder headers match Head Folders on the AR screen.
      folders: {
        team_discussions: "مناقشات الفريق",
        overall_audit_strategy: "استراتيجية المراجعة الشاملة",
        client_meetings_deliverables: "اجتماعات العميل ومخرجات المكتب",
        time_budget: "الموازنة الزمنية",
        materiality: "الأهمية النسبية",
        specialized: "متخصصة \u2068(400/401/402(a))\u2069",
        identified_risks: "المخاطر المُحدَّدة (تقارير المخاطر)",
        control_design_fsa: "تصميم الرقابة (بما في ذلك \u2066FSA\u2069)",
        risk_assessment_procedures: "إجراءات تقييم المخاطر",
        understanding_the_entity: "فهم المنشأة",
        accounting_estimates: "التقديرات المحاسبية",
        fraud_and_going_concern: "الاحتيال والاستمرارية",
        related_parties: "الأطراف ذات العلاقة",
        service_organizations: "منظمات الخدمات",
        sampling_basis_methodology: "أساس ومنهجية أخذ العينات",
        noclar: "الامتثال للقوانين واللوائح (\u2066NOCLAR\u2069)",
        misstatements: "التحريفات",
        subsequent_events: "الأحداث اللاحقة",
        reporting: "التقرير",
        documentation: "التوثيق",
        management_representation: "خطاب إفادات الإدارة",
        audit_completion: "قائمة إكمال المراجعة",
        report_approval: "اعتماد التقرير وإرساله",
        communications: "التواصل مع المكلفين بالحوكمة والإدارة",
        completion_support_documents: "مستندات دعم الإكمال",
        final_analytical_review: "المراجعة التحليلية النهائية",
        kam_determination: "الأمور الرئيسة للمراجعة",
        modified_opinion: "تقييم الرأي المعدَّل",
        eom_om_paragraphs: "فقرة لفت انتباه / أمر آخر",
        other_information_review: "مراجعة المعلومات الأخرى",
        comparative_information: "المعلومات المقارنة",
        management_letter_icd: "خطاب الإدارة (نقاط الضعف في الرقابة الداخلية)",
        special_purpose_framework: "تقارير الإطار ذي الغرض الخاص",
        single_fs_element: "قائمة مالية مفردة / عنصر محدَّد",
        summary_fs: "القوائم المالية الملخَّصة",
      },
      toastNoRefMatch: 'لا يوجد نموذج مطابق للمرجع "{ref}"',
      toastFormNotFound: "النموذج غير موجود في هذا الارتباط",
      bulkConfirm: 'تشغيل اقتراح الذكاء الاصطناعي على كل نموذج في تبويب "{tab}"؟ قد يستغرق ذلك دقيقة أو دقيقتين لتبويب كبير.',
      bulkNoJobId: "لم يُرجع الخادم معرف مهمة",
      bulkQueuedMsg: "في قائمة الانتظار…",
      bulkComplete: "اكتمل اقتراح الذكاء الاصطناعي — تم تحديث {done} من {total} نموذجًا{failed}",
      bulkCompleteFailedTail: " · فشل {failed}",
      bulkFailed: "فشل اقتراح الذكاء الاصطناعي بالجملة",
      bulkFailedGeneric: "تعذر بدء اقتراح الذكاء الاصطناعي بالجملة",
      pdfReady: "ملف PDF جاهز",
      pdfFailed: "فشل تصدير ملف PDF",
      noRollMsg: "لم يتم ترحيل أي نماذج من السنة السابقة — إما أن جميع النماذج لديها إدخالات لهذه السنة، أو لا يوجد شيء لترحيله.",
      rolledMsg: "تم ترحيل {n} من السنة المالية {year}. راجع كل نموذج واحفظه.",
      addonsCarriedMsg: " تم ترحيل {n} من السنة السابقة.",
      rollFailed: "فشل الترحيل",
      noQueryMatch: 'لا يوجد نموذج مطابق لـ "{q}"',
      loading: "جاري تحميل مكتبة النماذج…",
      selectEngagement: "اختر مهمة من الشريط العلوي لعرض نماذج {tab}.",
      tabNotFound: 'التبويب "{tabId}" غير موجود في مكتبة النماذج.',
      totalItems: "{folders} مجلدات · {total} بند إجمالي",
      searchPlaceholder: "ابحث برقم المرجع… (مثال 104)",
      noMatches: "لا توجد نتائج",
      sortFolder: "مجلد",
      sortRefNo: "رقم المرجع",
      rollForwardBtn: "ترحيل السنة السابقة",
      aiSuggestingLabel: "اقتراح الذكاء الاصطناعي… {pct}%",
      aiSuggestAllBtn: "اقتراح الذكاء الاصطناعي للكل",
      exportPdfBtn: "تصدير PDF",
      completionLabel: "الإكمال",
      allByRef: "كل النماذج حسب رقم المرجع",
      dragDisabledPre: "تعطيل السحب — بدّل إلى ",
      dragDisabledFolderBold: "مجلد",
      dragDisabledPost: " لإعادة الترتيب",
      notApplicableBadge: "غير قابل للتطبيق",
      markApplicableTitle: "تحديد كقابل للتطبيق",
      markNaTitle: "تحديد كغير قابل للتطبيق",
      naReasonPrompt: "لماذا هذا النموذج غير قابل للتطبيق؟ (سبب قصير يُسجَّل على النموذج وفي عرض التوقيعات)", naReasonRequired: "يلزم سبب قصير لتحديد النموذج كغير قابل للتطبيق.",   // Batch 14 · M11
      markedApplicable: "تم التحديد كقابل للتطبيق",
      markedNa: "تم التحديد كغير قابل للتطبيق",
      deletePermanentlyTitle: "حذف نهائي",
      rollDialogTitle: "الترحيل من السنة السابقة",
      rollDialogBodyPre: "يقوم هذا بنسخ إجابات نماذج السنة الماضية لهذا العميل إلى المهمة الحالية. فقط النماذج التي ",
      rollDialogBodyBold: "لم تلمسها بعد",
      rollDialogBodyPost: " سيتم ملؤها — لن يتم استبدال عملك الحالي أبدًا. يتم مسح حقول التوقيع والتاريخ تلقائيًا.",
      carryAddonsBold: "ترحيل النماذج الإضافية من السنة السابقة أيضًا.",
      carryAddonsBody: " إذا كان لدى مهمة السنة السابقة نماذج إضافية (مثل 211(أ) الأطراف ذات العلاقة، 313(أ) التأكيدات الخارجية) مضافة من مكتبة المستندات، فسيتم إضافتها إلى هذه المهمة أيضًا حتى يبقى برنامج المراجعة مستقرًا من سنة إلى سنة.",
      cancelBtn: "إلغاء",
      rollingLabel: "جاري الترحيل…",
      continueBtn: "متابعة",
    },
    formRenderer: {
      loadingForm: "جاري تحميل النموذج…",
      failedLoad: "فشل تحميل النموذج",
      savedToast: "تم الحفظ",
      failedSave: "فشل الحفظ",
      aiConfirm: "سيقوم اقتراح الذكاء الاصطناعي بمسودة إجابات نعم/لا/غير قابل للتطبيق لكل بند في قائمة التحقق على هذا النموذج، باستخدام ملخص الأستاذ للمهمة وإجابات السنة السابقة. سيتم استبدال إجاباتك الحالية على هذه البنود (مسودة فقط — ستقوم بالمراجعة والحفظ بنفسك). هل تريد المتابعة؟",
      aiDrafting: "جاري صياغة اقتراحات الذكاء الاصطناعي… قد يستغرق 10-30 ثانية.",
      aiDraftedPrefix: "قامت الذكاء الاصطناعي بصياغة",
      aiDraftedSuffixPY: " (بناءً على السنة السابقة)",
      aiDraftedTail: ". راجع كل بند ثم احفظ.",
      aiSuggestFailed: "فشل اقتراح الذكاء الاصطناعي",
      discardConfirm: "تجاهل التغييرات غير المحفوظة؟",
      notApplicable: "غير قابل للتطبيق",
      supportDocs: "مستندات داعمة لهذا النموذج",
      letterBody: "متن الخطاب (قابل للتعديل)",
      letterPlaceholder: "قم بصياغة خطاب إقرارات الإدارة هنا — المواضيع: القوائم المالية، المعلومات المقدمة، الاحتيال، القوانين واللوائح، الاستمرارية. يجب أن يطابق تاريخ الخطاب تاريخ تقرير المدقق.",
      letterDate: "تاريخ الخطاب",
      letterAttached: "الخطاب الموقّع مرفق",
      letterNotAttached: "لم يُرفق الخطاب الموقّع بعد — ارفعه ضمن المستندات الداعمة أدناه",
      letterRule: "يُعدّ مجابًا عند وجود نص الخطاب وإرفاق الخطاب الموقّع وإدخال التاريخ.",
      naReason: "السبب: {reason}", naReasonNotRecorded: "لم يُسجَّل سبب",   // Batch 14 · M11
      fromRecord: "معروض من {source} (مصدر واحد) — عدّله هناك.",
      fromRecordOpen: "فتح صفحة الأهمية النسبية",
      ajeRegisterNote: "مملوء من قيود التسوية المرحّلة (مصدر واحد) — للقراءة فقط هنا.",
      ajeManualRow: "يدوي (قبل قيود التسوية)",
      ajeOpen: "فتح قيود التسوية",
      documentReviewTab: "مراجعة المستندات",
      docRepoNote: "حالياً، استخدم تبويب {docReview} الرئيسي لرفع الملفات وربطها هنا يدوياً عبر أرقام المرجع. سيتوفر رافع المستندات المدمج لهذا النموذج في الإصدار التالي.",
      close: "إغلاق",
      savingBtn: "جاري الحفظ…",
      saveBtn: "حفظ",
      selectOption: "— اختر —",
      typeName: "اكتب الاسم الكامل",
      signedAtAuto: "تاريخ التوقيع (تلقائي)",
      commentOptional: "تعليق (اختياري)",
      aiSuggestedReview: "اقتراح ذكاء اصطناعي — يتطلب مراجعة",
      aiSuggestBtn: "اقتراح ذكاء اصطناعي",
      addRow: "إضافة صف",
      lastSaved: "آخر حفظ {when} بواسطة {by}",
      savedFooter: "تم الحفظ · {when} · {by}",
      notSavedYet: "لم يتم الحفظ بعد",
      refPrefix: "مرجع: {ref}",
    },
  },
};

export default I18N_BASE_FORMS;
